import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

interface SendNoriOutreachRequest {
  message: string;
}

interface SendNoriOutreachResponse {
  success: boolean;
}

interface SendNoriOutreachError {
  detail: string;
}

interface UseSendNoriOutreachParams {
  roomToken: string | undefined;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useSendNoriOutreach = ({
  roomToken,
  onSuccess,
  onError,
}: UseSendNoriOutreachParams) => {
  return useApiMutation<
    SendNoriOutreachResponse,
    SendNoriOutreachRequest,
    SendNoriOutreachError
  >({
    mutationOptions: {
      mutationKey: ["send-nori-outreach", roomToken],
      mutationFn: async (data: SendNoriOutreachRequest) => {
        if (!roomToken) {
          throw new Error("No room token available");
        }
        const response = await axiosInstance.post(
          `new-api/universal-clinic/chat/conversations/${roomToken}/send-outreach`,
          data,
        );
        return response.data;
      },
      onSuccess,
      onError,
    },
  });
};
